import { SET_PARTNERS } from './partners.actions';

const initialState = {
  partners: [],
};

export const partnersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PARTNERS:
      return {
        ...state,
        partners: payload,
      };
    default:
      return state;
  }
};
